import { initializeFilterPage, updateResults } from "@/scripts/common/filter-page";
import delegate from 'delegate-it';

const setupBadgeFilters = () => {
  if (document.querySelector('[data-category-filter]')) {
    delegate('[data-category-filter]', 'click', handleBadgeClick);
  }
};

const handleBadgeClick = (e) => {
  e.preventDefault();

  const badge = e.delegateTarget;
  const categoryValue = badge.dataset.categoryFilter;
  const form = document.querySelector(".filter-form");

  if (form) {
    const categorySelect = form.querySelector('select[name="category"]');
    if (categorySelect) {
      categorySelect.value = categoryValue;

      const changeEvent = new Event('change', { bubbles: true });
      categorySelect.dispatchEvent(changeEvent);
    } else {
      window.history.replaceState({}, "", `${form.action}?category=${categoryValue}`);
      updateResults(form, setupBadgeFilters);
    }
  } else {
    window.location.href = badge.href;
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initializeFilterPage(document.querySelector(".filter-form"), {
    setupExtraCallbacks: setupBadgeFilters
  });
});
